import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { I18nProvider } from './i18n';
import { CurrencyProvider } from './hooks/useCurrency';
import { AuthProvider } from './hooks/useAuth';
import { CartProvider } from './hooks/useCart';
import { SupportProvider } from './hooks/useSupport';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado no index.html');

createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <AuthProvider>
            <CartProvider>
              {/* Envolve o App inteiro: o item "Dúvidas" do menu vive no
                  cabeçalho, e a janela, no rodapé. */}
              <SupportProvider>
                <App />
              </SupportProvider>
            </CartProvider>
          </AuthProvider>
        </BrowserRouter>
      </CurrencyProvider>
    </I18nProvider>
  </StrictMode>,
);
